module.exports = __webpack_public_path__ + "static/media/expohall.add48d51.svg";